module.exports = __webpack_public_path__ + "static/media/android-download.e65a89bc.png";